import { render, staticRenderFns } from "./FrailtyAssessment.vue?vue&type=template&id=108d700f"
import script from "./FrailtyAssessment.vue?vue&type=script&lang=js"
export * from "./FrailtyAssessment.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports